import { useContext } from "react"
import { ModulosFornecedorContext } from "./ModulosFornecedorContext"

export function useModulosFornecedorContext() {
    return useContext(ModulosFornecedorContext)
}
